import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import VocabularyTraining from '../components/vocabulary/VocabularyTraining';
import { LoginPrompt } from '../components/LoginPrompt';
import { Brain, Flame } from 'lucide-react';
import { getUserStats } from '../services/vocabularyService';
import { useSearchParams } from 'react-router-dom';

const TrainingPage: React.FC = () => {
  const { currentUser, loading } = useAuth();
  const [streak, setStreak] = useState(0);
  const [searchParams] = useSearchParams();
  const theme = searchParams.get('theme') || undefined;

  useEffect(() => {
    if (currentUser?.uid) {
      getUserStats(currentUser.uid).then(stats => {
        setStreak(stats.streakCount || 0);
      });
    }
  }, [currentUser]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-50 to-white">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600" />
      </div>
    );
  }

  if (!currentUser) {
    return (
      <LoginPrompt
        title="Login Required for Daily Training"
        description="You need to be logged in to access Daily Training and track your progress. Create an account or login to start your learning journey!"
        featureName="Daily Training"
        icon={<Brain className="w-10 h-10 text-purple-600" />}
      />
    );
  }

  return (
    <div className="relative">
      <div className="container mx-auto px-4 py-4 md:absolute md:top-0 md:right-0 md:w-auto z-10 flex justify-end">
         {streak > 0 && (
           <div className="bg-purple-100 border border-purple-200 text-purple-700 px-4 py-2 rounded-full flex items-center gap-2 shadow-sm animate-pulse">
             <Brain className="w-5 h-5 fill-purple-500 text-purple-600" />
             <span className="font-bold text-base">{streak} Day Streak</span>
           </div>
         )}
      </div>
      <VocabularyTraining themeId={theme} />
    </div>
  );
};

export default TrainingPage;
